import styled from 'styled-components';

export const ToggleCheckbox = styled.label`
  position: relative;
  display: inline-block;
  width: 45px;
  height: 28px;
  float: right;

  input {
    display: none;
  }

  .toggle-switch {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 34px;
    background: #c1c9de;
    transition: .2s;
  }

  .toggle-switch:before {
    position: absolute;
    content: "";
    height: 22px;
    width: 22px;
    left: 3px;
    bottom: 3px;
    background: white;
    border-radius: 50%;
    transition: .2s;
  }

  .active-toggle-switch {
    background: #3ac1ee;
  }

  .active-toggle-switch:before {
    left: -6px;
  }

  .active-toggle-switch {
    box-shadow: 0 0 1px #2196F3;
  }

  .active-toggle-switch:before {
    transform: translateX(26px);
  }
`;



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/searchBox/styles/ToggleCheckbox.js